import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { isEmptySlateNodeValue } from '@doltech/utils/lib/editor';
import { ResponsiveTypography } from '../../../figma/Typography/v3/ResponsiveTypography';
import { GAP_FILL_WITH_HINT_PARAGRAPH_TOGGLE_TYPES } from '../types';

const Content = styled.div``;

const Container = styled.div``;

export const GapFillWithHintParagraphToggle = (props: RenderElementProps) => {
  const { element, children, attributes } = props;
  const isEmpty = isEmptySlateNodeValue(element);

  if (isEmpty) {
    return null;
  }

  switch (element.present) {
    case GAP_FILL_WITH_HINT_PARAGRAPH_TOGGLE_TYPES.QUESTION_CONTENT:
      return <QuestionContent {...props} />;
    default:
      return <div {...attributes}>{children}</div>;
  }
};

const QuestionContent = (props: RenderElementProps) => {
  const { children, attributes } = props;
  return (
    <Container className="paragraph-toggle-gap-fill question-content" {...attributes}>
      <Content>
        <ResponsiveTypography.Paragraph className="question-text" variant="regular/16-28" color="neutral180">
          {children}
        </ResponsiveTypography.Paragraph>
      </Content>
    </Container>
  );
};
